import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text } from '@backstage/ui';

import { DateUtils } from '@spotify/confidence-core-react';
import { IdentityRefFragment } from '@spotify/confidence-graphql';
import { IdentityAvatar } from '@spotify/plugin-confidence-iam-react';

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: 'var(--bui-space-2) var(--bui-space-2)',
      paddingLeft: 0,
    },
    avatar: {
      width: '18px',
      height: '18px',
      marginRight: 'var(--bui-space-2)',
      flexShrink: 0,
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
  });

export interface HeaderProps extends WithStyles<typeof styles> {
  className?: string;
  actor: IdentityRefFragment;
  timestamp: string;
}

const Header = ({ actor, timestamp, classes, className }: HeaderProps) => (
  <div className={classNames(classes.root, className)}>
    <IdentityAvatar className={classes.avatar} identityRef={actor} />
    <div className={classes.content}>
      <Text as="div" variant="body-small" color="secondary" truncate>
        {DateUtils.xAgo(new Date(timestamp))} &bull; {actor.displayName}
      </Text>
    </div>
  </div>
);

export default withStyles(styles)(Header);
